import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.0.2_next@15.3.2_@babel+core@7.26.10_@opentelemetry+api@1.7.0_@playwright+te_1ad5fd76d10ce33c0da145ae23ef2158/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.0.2_next@15.3.2_@babel+core@7.26.10_@opentelemetry+api@1.7.0_@playwright+te_1ad5fd76d10ce33c0da145ae23ef2158/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.3.2_@babel+core@7.26.10_@opentelemetry+api@1.7.0_@playwright+test@1.43.1_react-_7b9e13b19f60ed89bad4f2073e6e9178/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.2_@babel+core@7.26.10_@opentelemetry+api@1.7.0_@playwright+test@1.43.1_react-_7b9e13b19f60ed89bad4f2073e6e9178/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/typescript/apps/worker-web/public/images/button-dl-appstore.png");
;
import(/* webpackMode: "eager" */ "/app/typescript/apps/worker-web/public/images/button-dl-googleplaystore.png");
;
import(/* webpackMode: "eager" */ "/app/typescript/apps/worker-web/public/images/image-catchphrase-center.svg");
;
import(/* webpackMode: "eager" */ "/app/typescript/apps/worker-web/public/images/image-catchphrase-left.svg");
;
import(/* webpackMode: "eager" */ "/app/typescript/apps/worker-web/public/images/image-screen-1.png");
;
import(/* webpackMode: "eager" */ "/app/typescript/apps/worker-web/public/images/image-screen-2.png");
;
import(/* webpackMode: "eager" */ "/app/typescript/apps/worker-web/public/images/logo-symbol.svg");
;
import(/* webpackMode: "eager", webpackExports: ["LogScreenDisplay"] */ "/app/typescript/apps/worker-web/src/libs/clientEvents/LogScreenDisplay.tsx");
